import React, { useState, useEffect } from "react";
import { Button, Form, Modal , InputGroup , ListGroup , Badge } from "react-bootstrap";
import {FaPlus,FaEdit,FaTrash,FaCheck,FaTimes} from 'react-icons/fa'
import axiosInstance from "../../utils/axiosUtil";
import "../../css/EditPlan.css"

export default function EditPlan({ show, plan, onClose, onUpdated, onError }) {
  const [formData, setFormData] = useState({
    name: "",
    totalPrice: "",
    discountedPrice: "",
    isActive: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
   const [features, setFeatures] = useState([]);
  const [newFeature, setNewFeature] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  useEffect(() => {
    if (plan) {
      setFormData({
        name: plan.name || "",
        totalPrice: plan.totalPrice?.toString() || "",
        discountedPrice: plan.discountedPrice?.toString() || "",
        isActive: plan.isActive !== undefined ? plan.isActive : true
      });
     setFeatures(plan.features || []);
      setError("");
      setNewFeature("");
      setEditingIndex(null);
      setEditingValue("");
    }
  }, [plan]);




// ******************************

const handleAddFeature = () => {
    const trimmedFeature = newFeature.trim();
    if (!trimmedFeature) {
      return;
    }
    
    // Check for duplicates
    if (features.some(f => f.toLowerCase() === trimmedFeature.toLowerCase())) {
      setError("This feature already exists.");
      return;
    }

    setFeatures((prev) => [...prev, trimmedFeature]);
    setNewFeature("");
    setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddFeature();
    }
  };

  const handleRemoveFeature = (index) => {
    setFeatures((prev) => prev.filter((_, i) => i !== index));
    // Reset editing state if we're removing the item being edited
    if (editingIndex === index) {
      setEditingIndex(null);
      setEditingValue("");
    } else if (editingIndex > index) {
      // Adjust editing index if we removed an item before it
      setEditingIndex(editingIndex - 1);
    }
  };

  const handleStartEdit = (index) => {
    setEditingIndex(index);
    setEditingValue(features[index]);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingValue("");
  };

  const handleSaveEdit = () => {
    const trimmedValue = editingValue.trim();
    if (!trimmedValue) {
      setError("Feature cannot be empty.");
      return;
    }

    // Check for duplicates (excluding current item)
    const isDuplicate = features.some(
      (f, i) => i !== editingIndex && f.toLowerCase() === trimmedValue.toLowerCase()
    );
    
    if (isDuplicate) {
      setError("This feature already exists.");
      return;
    }

    setFeatures((prev) =>
      prev.map((feature, i) => (i === editingIndex ? trimmedValue : feature))
    );
    setEditingIndex(null);
    setEditingValue("");
    setError("");
  };

  const handleEditKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSaveEdit();
    } else if (e.key === "Escape") {
      handleCancelEdit();
    }
  };






// ********************************


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!formData.name.trim()) {
      setError("Plan name is required.");
      setLoading(false);
      return;
    }

    const totalPrice = parseFloat(formData.totalPrice);
    const discountedPrice = parseFloat(formData.discountedPrice);

    if (isNaN(totalPrice) || totalPrice < 0) {
      setError("Total price must be a valid positive number.");
      setLoading(false);
      return;
    }

    if (isNaN(discountedPrice) || discountedPrice < 0) {
      setError("Discounted price must be a valid positive number.");
      setLoading(false);
      return;
    }

    if (discountedPrice > totalPrice) {
      setError("Discounted price cannot be greater than total price.");
      setLoading(false);
      return;
    }

    try {
      const { data } = await axiosInstance.put(`/plans/${plan._id}`, {
        name: formData.name.trim(),
        totalPrice: totalPrice,
        discountedPrice: discountedPrice,
        isActive: formData.isActive,
        features:features,
      });

      onUpdated(data);
    } catch (err) {
      const errorMessage = err?.response?.data?.message || "Failed to update plan";
      setError(errorMessage);
      if (onError) {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setError("");
    setFormData({
      name: "",
      totalPrice: "",
      discountedPrice: "",
      isActive: true
    });
     setFeatures([]);
    setNewFeature("");
    setEditingIndex(null);
    setEditingValue("");
    onClose();
  };

  // return (
  //   <Modal show={show} onHide={handleClose} size="lg">
  //     <Modal.Header closeButton>
  //       <Modal.Title>Edit Plan</Modal.Title>
  //     </Modal.Header>
  //     <Form onSubmit={handleSubmit}>
  //       <Modal.Body>
  //         {error && (
  //           <div className="alert alert-danger" role="alert">
  //             {error}
  //           </div>
  //         )}

  //         <Form.Group className="mb-3">
  //           <Form.Label>
  //             Plan Name <span className="text-danger">*</span>
  //           </Form.Label>
  //           <Form.Control
  //             type="text"
  //             name="name"
  //             value={formData.name}
  //             onChange={handleChange}
  //             placeholder="Enter plan name"
  //             required
  //           />
  //         </Form.Group>

  //         <Form.Group className="mb-3">
  //           <Form.Label>
  //             Total Price <span className="text-danger">*</span>
  //           </Form.Label>
  //           <Form.Control
  //             type="number"
  //             name="totalPrice"
  //             value={formData.totalPrice}
  //             onChange={handleChange}
  //             placeholder="Enter total price"
  //             min="0"
  //             step="0.01"
  //             required
  //           />
  //         </Form.Group>

  //         <Form.Group className="mb-3">
  //           <Form.Label>
  //             Discounted Price <span className="text-danger">*</span>
  //           </Form.Label>
  //           <Form.Control
  //             type="number"
  //             name="discountedPrice"
  //             value={formData.discountedPrice}
  //             onChange={handleChange}
  //             placeholder="Enter discounted price"
  //             min="0"
  //             step="0.01"
  //             required
  //           />
  //           <Form.Text className="text-muted">
  //             Discounted price must be less than or equal to total price.
  //           </Form.Text>
  //         </Form.Group>

  //         <Form.Group className="mb-3">
  //           <Form.Check
  //             type="checkbox"
  //             name="isActive"
  //             label="Active"
  //             checked={formData.isActive}
  //             onChange={handleChange}
  //           />
  //         </Form.Group>
  //       </Modal.Body>
  //       <Modal.Footer>
  //         <Button variant="secondary" onClick={handleClose} disabled={loading}>
  //           Cancel
  //         </Button>
  //         <Button variant="primary" type="submit" disabled={loading}>
  //           {loading ? "Saving..." : "Save Changes"}
  //         </Button>
  //       </Modal.Footer>
  //     </Form>
  //   </Modal>
  // );

return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edit Plan</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <Form.Group className="mb-3">
            <Form.Label>
              Plan Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter plan name"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Total Price <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              name="totalPrice"
              value={formData.totalPrice}
              onChange={handleChange}
              placeholder="Enter total price"
              min="0"
              step="0.01"
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>
              Discounted Price <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              name="discountedPrice"
              value={formData.discountedPrice}
              onChange={handleChange}
              placeholder="Enter discounted price"
              min="0"
              step="0.01"
              required
            />
            <Form.Text className="text-muted">
              Discounted price must be less than or equal to total price.
            </Form.Text>
          </Form.Group>

          {/* Features Section */}
          <Form.Group className="mb-3">
            <Form.Label className="features-label">
              Features
              <Badge bg="secondary" className="features-count">
                {features.length}
              </Badge>
            </Form.Label>
            
            <InputGroup className="feature-input-group">
              <Form.Control
                type="text"
                value={newFeature}
                onChange={(e) => setNewFeature(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Add a new feature..."
                className="feature-input"
              />
              <Button
                variant="success"
                onClick={handleAddFeature}
                disabled={!newFeature.trim()}
                className="add-feature-btn"
              >
                <FaPlus />
              </Button>
            </InputGroup>

            {features.length > 0 && (
              <ListGroup className="features-list">
                {features.map((feature, index) => (
                  <ListGroup.Item key={index} className="feature-item">
                    {editingIndex === index ? (
                      <div className="feature-edit-container">
                        <Form.Control
                          type="text"
                          value={editingValue}
                          onChange={(e) => setEditingValue(e.target.value)}
                          onKeyDown={handleEditKeyPress}
                          className="feature-edit-input"
                          autoFocus
                        />
                        <div className="feature-edit-actions">
                          <Button
                            variant="success"
                            size="sm"
                            onClick={handleSaveEdit}
                            className="feature-action-btn"
                          >
                            <FaCheck />
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={handleCancelEdit}
                            className="feature-action-btn"
                          >
                            <FaTimes />
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="feature-display-container">
                        <span className="feature-text">{feature}</span>
                        <div className="feature-actions">
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => handleStartEdit(index)}
                            className="feature-action-btn"
                          >
                            <FaEdit />
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleRemoveFeature(index)}
                            className="feature-action-btn"
                          >
                            <FaTrash />
                          </Button>
                        </div>
                      </div>
                    )}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}

            {features.length === 0 && (
              <div className="no-features-message">
                No features added yet. Add your first feature above.
              </div>
            )}
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              name="isActive"
              label="Active"
              checked={formData.isActive}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );

}

